import { canUseDOM } from 'exenv';

export enum Portals {
  before = 'portal-before-root',
  after = 'portal-after-root',
  mobileBanner = 'cpa-mobile-banner'
}

export default (portal: Portals) => {
  if (!canUseDOM) {
    return null;
  }

  return document.getElementById(portal);
};
